import { render } from "./main-component.vue?vue&type=template&id=aef42742&scoped=true"
import script from "./main-component.vue?vue&type=script&lang=js"
export * from "./main-component.vue?vue&type=script&lang=js"

import "./main-component.vue?vue&type=style&index=0&id=aef42742&scoped=true&lang=css"

import exportComponent from "D:\\playground\\canada-cars\\Kia\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef42742"]])

export default __exports__